<script>

import { computed, reactive, ref } from 'vue';
export default {
  name: 'Program',
  setup() {
    const tableData = ref([
    {
      day: 'Day 1: Feb.13',
      time: 'AM10-PM6:00',
      activity: 'Registration',
      hoster: 'Conference team, Maxium Academic Press',
      participates: ''
    },
    {
      day: 'Day 1: Feb.13',
      time: 'PM6:00-9:00',
      activity: 'Buffet dinner',
      hoster: '',
      participates: ''
    },
    {
      day: 'Day 1: Feb.13',
      time: 'PM8:30-9:30',
      activity: 'Tropical Plant Journal Editorial Board meeting',
      hoster: 'Wenquan Wang',
      participates: 'All AEs and young scientists members'
    },
    {
      day: 'Day 2: Feb.14',
      time: 'AM8:30-9:00',
      activity: 'Opining ceremony [Speech: Jihua Wang, Yongping Yang, Hong Li,Bing Cao and Henry Robert]',
      hoster: 'Jie Luo Chengyun Li',
      participates: 'All delegates'
    },
    {
      day: 'Day 2: Feb.14',
      time: 'AM9:00-9:40',
      activity: 'Keynote speaker: Charles Cannon',
      hoster: 'Jie Luo Chengyun Li',
      participates: 'All delegates'
    },
    {
      day: 'Day 2: Feb.14',
      time: 'AM9:40-10:20',
      activity: 'Keynote speaker:Henry Robert',
      hoster: '',
      participates: 'All delegates'
    },
    {
      day: 'Day 2: Feb.14',
      time: 'AM10:20-10:50',
      activity: 'Group photography and Tea break',
      hoster: 'Peng Xu',
      participates: 'All delegates'
    },
    {
      day: 'Day 2: Feb.14',
      time: 'AM10:50-11:30',
      activity: 'Keynote speaker: Hong Li',
      hoster: 'Peng Xu',
      participates: 'All delegates'
    },
    {
      day: 'Day 2: Feb.14',
      time: 'AM11:30-PM12:10',
      activity: 'Keynote speaker:Yongping Yang',
      hoster: 'Peng Xu',
      participates: 'All delegates'
    },
    {
      day: 'Day 2: Feb.14',
      time: 'PM12:10-2:00',
      activity: 'Lunch',
      hoster: '',
      participates: ''
    },
    {
      day: 'Day 2: Feb.14',
      time: 'PM2:00-6:00',
      activity: 'Session presentation',
      hoster: '',
      participates: 'Optional participation'
    },
    {
      day: 'Day 2: Feb.14',
      time: 'Session1: Room',
      activity: 'Gene discovery and genteic breeding in tropical plant',
      hoster: 'Henry Robert',
      participates: ''
    },
    {
      day: 'Day 2: Feb.14',
      time: 'Session2: Room',
      activity: 'Metabolomics and Nutritional Health',
      hoster: 'Jie Luo',
      participates: ''
    },
    {
      day: 'Day 2: Feb.14',
      time: 'Session3: Room',
      activity: 'Smart Agriculture and Forestry and Plant Protection in Tropics',
      hoster: 'Chengyun Li',
      participates: ''
    },
    {
      day: 'Day 2: Feb.14',
      time: 'Session4: Room',
      activity: 'Multiomics, database and technological tools',
      hoster: 'Zhiqiang Xia',
      participates: ''
    },
    {
      day: 'Day 2: Feb.14',
      time: 'Session5: Room',
      activity: 'Ecological Conservation of Tropical Rainforests',
      hoster: 'Wen-Bin Yu',
      participates: ''
    },
    {
      day: 'Day 2: Feb.14',
      time: 'PM4:00-4:20',
      activity: 'Tea break',
      hoster: '',
      participates: ''
    },
    {
      day: 'Day 2: Feb.14',
      time: 'PM6:00-7:30',
      activity: 'Welcome Banquet',
      hoster: 'Conference team',
      participates: 'Guangwei Scientific Company'
    },
    {
      day: 'Day 3: Feb.15',
      time: 'AM8:30-12:00',
      activity: 'Session presentation',
      hoster: '',
      participates: 'Optional participation'
    },
    {
      day: 'Day 3: Feb.15',
      time: 'Session1: Room',
      activity: 'Gene discovery and genteic breeding in tropical plant',
      hoster: 'Xingtan Zhang',
      participates: ''
    },
    {
      day: 'Day 3: Feb.15',
      time: 'Session2: Room',
      activity: 'Metabolomics and Nutritional Health',
      hoster: 'Peng Xu',
      participates: ''
    },
    {
      day: 'Day 3: Feb.15',
      time: 'Session3: Room',
      activity: 'Smart Agriculture and Forestry and Plant Protection in Tropics',
      hoster: 'Shaoying Wu',
      participates: ''
    },
    {
      day: 'Day 3: Feb.15',
      time: 'Session4: Room',
      activity: 'Multiomics, database and technological tools',
      hoster: 'Fei Chen',
      participates: ''
    },
    {
      day: 'Day 3: Feb.15',
      time: 'Session5: Room',
      activity: 'Ecological Conservation of Tropical Rainforests',
      hoster: 'Charles Cannon',
      participates: ''
    },
    {
      day: 'Day 3: Feb.15',
      time: 'AM10:30-10:50',
      activity: 'Tea break',
      hoster: '',
      participates: 'All participates'
    },
    {
      day: 'Day 3: Feb.15',
      time: 'AM12:00-PM12:30',
      activity: 'Lunch',
      hoster: '',
      participates: 'All participates'
    },
    {
      day: 'Day 3: Feb.15',
      time: 'PM2:00-6:00',
      activity: 'Keynote Speeching time',
      hoster: 'Guanghua Liu',
      participates: ''
    },
    {
      day: 'Day 3: Feb.15',
      time: 'PM2:00-2:40',
      activity: 'Keynote Speaker: Jie Luo',
      hoster: 'Guanghua Liu',
      participates: ''
    },
    {
      day: 'Day 3: Feb.15',
      time: 'PM2:40-3:20',
      activity: 'Keynote Speaker: Sanwen Huang',
      hoster: 'Guanghua Liu',
      participates: ''
    },
    {
      day: 'Day 3: Feb.15',
      time: 'PM3:20-4:00',
      activity: 'Keynote Speaker: Chengyun Li',
      hoster: 'Guanghua Liu',
      participates: ''
    },
    {
      day: 'Day 3: Feb.15',
      time: 'PM4:00-4:20',
      activity: 'Tea break',
      hoster: '',
      participates: ''
    },
    {
      day: 'Day 3: Feb.15',
      time: 'PM4:20-5:00',
      activity: 'Keynote speaker: Bo Zhou(FAO Asia Pacific Office)',
      hoster: 'Xintan Zhang',
      participates: ''
    },
    {
      day: 'Day 3: Feb.15',
      time: 'PM5:00-5:20',
      activity: 'Keynote speaker: Wenquan Wang',
      hoster: 'Xintan Zhang',
      participates: ''
    },
    {
      day: 'Day 3: Feb.15',
      time: 'PM5:20-5:50',
      activity: 'Discussion for development of Tropical Agriculture and Ecology',
      hoster: 'Zongming Cheng',
      participates: ''
    },
    {
      day: 'Day 3: Feb.15',
      time: 'PM5:50-6:00',
      activity: 'Conference summary and closing ceremony',
      hoster: 'Guanghua Liu, Wenquan Wang',
      participates: ''
    },
    {
      day: 'Day 3: Feb.15',
      time: 'PM6:00-7:30',
      activity: 'Buffet dinner',
      hoster: '',
      participates: ''
    },
    {
      day: 'Day 4: Feb.16',
      time: '',
      activity: 'Visiting and leave for home',
      hoster: 'Conference team',
      participates: ''
    }]
    );

    const spanMethod = ({ row, column, rowIndex, columnIndex }) => {
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: 3,
            colspan: 1
          };
        } else if (rowIndex === 1 || rowIndex === 2) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
        if (rowIndex === 3) {
          return {
            rowspan: 15,
            colspan: 1
          };
        } else if (rowIndex > 3 && rowIndex <= 17) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
        if (rowIndex === 18) {
          return {
            rowspan: 17,
            colspan: 1
          };
        } else if (rowIndex > 18 && rowIndex <= 34) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      if (columnIndex === 3) {
        if (rowIndex === 3) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else if (rowIndex === 4) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
        if (rowIndex === 6) {
          return {
            rowspan: 3,
            colspan: 1
          };
        } else if (rowIndex > 6 && rowIndex <= 8) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
        if (rowIndex === 26) {
          return {
            rowspan: 4,
            colspan: 1
          };
        } else if (rowIndex > 26 && rowIndex <= 29) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      if (columnIndex === 4) {
        if (rowIndex === 3) {
          return {
            rowspan: 6,
            colspan: 1
          };
        } else if (rowIndex > 3 && rowIndex <= 8) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    };

    const toggleSection = (index) => {
      sections[index].visible = !sections[index].visible;
    };

    const sections = reactive([
    { visible: true },
    { visible: true },
    { visible: true }]
    );
    const conferenceSchedule = ref([
    {
      date: 'Monday, March 23, 2026',
      time: '08:00 - 09:00',
      room: 'Fineen',
      activities: 'Registration',
      speaker: ''
    },
    {
      date: 'Monday, March 23, 2026',
      time: '09:00 - 09:30',
      room: 'Fineen',
      activities: 'Opening Remarks',
      speaker: "Dr. Damrong Sripraram\\nActing President of Kasetsart University\\nMs. Sirinporn Deawtrakul\\nDeputy Executive Director, National Research Council of Thailand (NRCT)"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '09:30 - 10:00',
      room: 'Fineen',
      activities: 'Keynote Speaker (1) | Advancing Thai Agriculture: Genome Editing for Global Sustainability and Economic Resilience',
      speaker: "Dr. Piyarat Thammakijjawat\\nDirector of Biotechnology Research and Development Office, Department of Agriculture, Ministry of Agriculture and Cooperatives"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '10:00 - 10:30',
      room: 'Fineen',
      activities: 'Keynote Speaker (2) | Online | The evolution and domestication of coconut',
      speaker: "Prof. Jie Luo\\nHainan University, Chief scientist of Multi-omics platform of Yazhoubay Laboratory, China"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '10:30 - 10:45',
      room: 'Fauna',
      activities: 'Coffee Break',
      speaker: ''
    },
    {
      date: 'Monday, March 23, 2026',
      time: '10:45 - 11:15',
      room: 'Fineen',
      activities: 'Keynote Speaker (3) | Engineering Tropical Plants to Replace Fossil Carbon',
      speaker: "Prof. Robert Henry\\nAcademician of Australian Academy of Technology and Engineering, University of Queensland, Australia"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '11:15 - 11:45',
      room: 'Fineen',
      activities: 'Keynote Speaker (4) | Cryptochromes and plant highlight responses',
      speaker: "Prof. Chengtao Lin\\nFujian Agriculture and Forestry University, China"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '11:45 - 12:15',
      room: 'Fineen',
      activities: 'Keynote Speaker (5) | From Germplasm to Global Markets: Advancing Coconut Research Excellence, Crop Protection, and Evidence-Based Governance',
      speaker: "Dr. Jelfina Alouw\\nDirector General International Coconut Community (ICC)"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '12:15 - 13:15',
      room: '',
      activities: 'Lunch',
      speaker: ''
    },
    {
      date: 'Monday, March 23, 2026',
      time: 'Oral Presentation',
      room: '',
      activities: 'Session 4: Smart Agriculture, Forestry, & Plant Protection in Tropical Regions',
      speaker: "Convener: Prof. Youxiong Que\\nProf. Huang Xi"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '13:15 - 13:30',
      room: 'Fineen',
      activities: 'Areca palm velarivirus 1 encoded proteins suppress antiviral RNA silencing by mediating the degradation of SGS3 and disrupting the SGS3-RDR6 interaction',
      speaker: 'Prof. Huang Xi'
    },
    {
      date: 'Monday, March 23, 2026',
      time: '13:30 - 13:45',
      room: 'Fineen',
      activities: 'Epigenetic regulation of chilling injury in banana fruit',
      speaker: "Prof Peitao Lu, Institute of Tropical Biosciences & Biotechnology, CATAS"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '13:45 - 14:00',
      room: 'Fineen',
      activities: '[O05] Regenerative Design for Agriculture Service Providers in Thailand: A Structured Analytical Review of Ecological, Economic, Organizational, Social, and Governance Transitions',
      speaker: "Nutchanon Phichadul, Ubon Ratchathani University"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '14:00 - 14:15',
      room: 'Fineen',
      activities: '[O12] Enhancing Tea Oil Yield of Camellia oleifera Through Optimized Root Zone Soil Management',
      speaker: "Nattaporn Prakongkep, Land Development Department"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '14:15 - 14:30',
      room: 'Fineen',
      activities: '[O14] Association Between Canopy Size from RGB Images and Destructively Measured Biomass for Growth Assessment in Holy Basil',
      speaker: "Thanapat Nilwaranon, Kasetsart University, Kamphaeng Saen Campus"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '14:30 - 14:45',
      room: 'Fineen',
      activities: '[O30] Synergistic Effects of Pre-harvest UV-A Supplementation and CO2 Enrichment on Physiological Traits and Phytonutrient Profiles of Kale',
      speaker: "Jutiporn Thussagunpanit, Kasetsart University"
    },
    {
      date: 'Monday, March 23, 2026',
      time: 'Oral Presentation',
      room: '',
      activities: 'Session 2: Physiological and Molecular Mechanisms of Stress Tolerance in Tropical Plants',
      speaker: "Convener: Prof. Dr. Yinghua Chen\\nAssoc.Prof. Sutkhet Nakasathien"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '13:15 - 13:30',
      room: 'Flavio',
      activities: '[O03] Single Nucleus RNA-sequencing for Understanding Secondary Cell Wall Patterning of Xylem Vessels',
      speaker: "Elvian Indah Nilamsari, Nara Institute of Science and Technology"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '13:30 - 13:45',
      room: 'Flavio',
      activities: '[O09] Molecular regulation of sugar accumulation in citrus under cold stress',
      speaker: "Liu, Ji-Hong, Huazhong Agricultural University"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '13:45 - 14:00',
      room: 'Flavio',
      activities: 'Regulation of Cassava Immune Response by Xpm typeIII effectors',
      speaker: "Yinhua Chen, Hainan University"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '14:00 - 14:15',
      room: 'Flavio',
      activities: 'Mechanisms of Xanthomonas phaseoli pv. Manihotis effector XopAG in Regulating Cassava Immune Response',
      speaker: "Liyun Yang, Hainan University"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '14:15 - 14:30',
      room: 'Flavio',
      activities: '[O07] Effect of chitosan coating combined with 1-Methylcyclopropene on postharvest quality and storage life of MD2 pineapple under low-temperature conditions',
      speaker: "Peerasak Chaiprasart, Naresuan University"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '14:30 - 14:45',
      room: 'Flavio',
      activities: '[O25] Toward Climate-Smart Rice: Integrative Genomic Approaches for Candidate Gene Discovery Under Drought-prone Environments',
      speaker: "Phanchita Vejchasarn, Rice Department"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '14:45 - 15:00',
      room: 'Flavio',
      activities: '[O29] Multi-omics approach reveals the mechanisms of salt tolerance in rice',
      speaker: "Supatthra Narawatthana, Thailand Rice Science Institute, Rice Department, MOAC"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '15:00 - 15:15',
      room: 'Fauna',
      activities: 'Coffee Break / Poster Session',
      speaker: ''
    },
    {
      date: 'Monday, March 23, 2026',
      time: 'Oral Presentation',
      room: '',
      activities: 'Session 6: Tropical Plants in Carbon Sequestration and the Bioeconomy',
      speaker: 'Convener: Prof. Peng Xu'
    },
    {
      date: 'Monday, March 23, 2026',
      time: '15:15 - 15:30',
      room: 'Fineen',
      activities: 'Aboveground Biomass of urban Trees and Its Driving Factors in Tropical Cities of Hainan',
      speaker: "Prof. Huafeng Wang, Hainan University (online)"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '15:30 - 15:45',
      room: 'Fineen',
      activities: 'The mechanism of grain amaranth tolerance to salt and alkali stress and its potential application in improving saline-alkali soil',
      speaker: "Dr. Jinpeng Wan, Xishuangbanna Tropical Botanical Garden, Chinese Academy of Sciences"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '15:45 - 16:00',
      room: 'Fineen',
      activities: 'Genetic basis of coordinated sugar and amino acid accumulation during abiu fruit ripening revealed by a T2T haplotype-resolved genome',
      speaker: "Dr. Yuhua Chen, Hainan University"
    },
    {
      date: 'Monday, March 23, 2026',
      time: 'Oral Presentation',
      room: '',
      activities: 'Session 2: Physiological and Molecular Mechanisms of Stress Tolerance in Tropical Plants (continued)',
      speaker: "Convener: Prof. Dr. Yinghua Chen\\nAssoc.Prof. Sutkhet Nakasathien"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '15:15 - 15:30',
      room: 'Flavio',
      activities: '[O02] Pushing through: QTL-Seq insight into root penetration under soil compaction in rice',
      speaker: "Suparad Klinsawang, Kasetsart University Kamphaeng Saen Campus"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '15:30 - 15:45',
      room: 'Flavio',
      activities: '[O06] Uncovering the Genetic Basis of Mega-Papillae Formation in Rice (Oryza sativa L.) Through QTL-seq and Genome-Wide Association Studies',
      speaker: "Watchara Phetluan, Center of Excellence on Agricultural Biotechnology: (AG-BIO/MHESI)"
    },
    {
      date: 'Monday, March 23, 2026',
      time: 'Oral Presentation',
      room: '',
      activities: 'Session 5: Discovery and Characterization of Novel Bioactive Compounds from Tropical Plants',
      speaker: 'Convener: TBC'
    },
    {
      date: 'Monday, March 23, 2026',
      time: '15:45 - 16:00',
      room: 'Flavio',
      activities: '[O13] Effect of CPPU and Boric Acid on Flower Induction of Off-season Lychee',
      speaker: "Thanarut Chinnapan, Maejo University"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '16:00 - 16:15',
      room: 'Flavio',
      activities: '[O24] From Aroma to Preference: Linking Volatile Profiles and Consumer Acceptance in Landrace Chilli (Capsicum spp.)',
      speaker: "Chutchamas Kanchana-udomkan, Kasetsart University, Kamphaeng Saen Campus"
    },
    {
      date: 'Monday, March 23, 2026',
      time: '16:15 - 17:15',
      room: 'Fauna',
      activities: 'Poster Session',
      speaker: ''
    },
    {
      date: 'Monday, March 23, 2026',
      time: '19:00 - 21:30',
      room: 'Z Beach',
      activities: 'Welcome Dinner',
      speaker: ''
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '09:00 - 09:30',
      room: 'Fineen',
      activities: 'Keynote Speaker (6) | Improving Rice to Sustain One Health',
      speaker: "Prof. Apichart Vanavichit\\nRice Science Center\\nKasetsart University Kamphaeng Saen Campus"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '09:30 - 10:00',
      room: 'Fineen',
      activities: 'Keynote Speaker (7) | From wild plants to novel calcium-rich vegetables',
      speaker: "Prof. Hongwen Huang\\nDirector of Lushan Botanical Garden\\nThe Chinese Academy of Sciences, China"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '10:00 - 10:15',
      room: 'Fauna',
      activities: 'Coffee Break',
      speaker: ''
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '10:15 - 10:45',
      room: 'Fineen',
      activities: 'Keynote Speaker (8) | Thai Sugar Industries: Toward Sustainability',
      speaker: "Assoc. Prof. Wirat Vanichsriratana\\nFaculty of Agro-Industry, Kasetsart University"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '10:45 - 11:15',
      room: 'Fineen',
      activities: 'Keynote Speaker (9) | The efficiency myth of polycrossing in cassava: evidence from the crossing nursery',
      speaker: "Dr. Sean Fenstemaker\\nThe Alliance of Bioversity International and CIAT, Columbia"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '11:15 - 11:45',
      room: 'Fineen',
      activities: 'Keynote Speaker (10) | Sugarcane breeding: theoretical thinking and practical exploration',
      speaker: "Prof. Youxiong Que\\nInstitute of Tropical Biosciences & Biotechnology, CATAS"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '11:45 - 12:15',
      room: 'Fineen',
      activities: 'Keynote Speaker (11) | Storage of the difficult mango, a climacteric fruit that refuses to play by the rules',
      speaker: "Prof. Dr. Randy Beaudry\\nMichigan State University, USA"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '12:15 - 13:15',
      room: '',
      activities: 'Lunch',
      speaker: ''
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: 'Session',
      room: '',
      activities: 'Session 7: Resilient Coconut Futures: Bridging Genetics, Smart Agriculture, and the Bioeconomy',
      speaker: ''
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '09:00 - 09:15',
      room: 'Vermillion',
      activities: 'Opening Remarks',
      speaker: "Dr. Jelfina C. Alouw, DG, ICC & KU president"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '09:15 - 09:45',
      room: 'Vermillion',
      activities: '[O16] Leveraging Molecular Breeding for Market Competitiveness',
      speaker: "Dr. Niral Vittal, CPCRI - India"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '09:45 - 10:15',
      room: 'Vermillion',
      activities: '[O17] Coconut Tissue Culture: Present Developments and Future Opportunities',
      speaker: "Dr. Bart Panis, Katholieke Universiteit te Leuven, Belgium"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '10:15 - 10:30',
      room: 'Vermillion',
      activities: 'Coffee Break',
      speaker: ''
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '10:30 - 11:00',
      room: 'Vermillion',
      activities: '[O18] Coconut agronomy and the evolving landscape of international trade',
      speaker: "Dr. Anjana Atapattu, CRI - Sri Lanka"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '11:00 - 11:30',
      room: 'Vermillion',
      activities: '[O15] Genomic & Molecular Breeding',
      speaker: "Dr. Samart Wanchana, NSTDA, Thailand"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '11:30 - 12:00',
      room: 'Vermillion',
      activities: '[O19] AI & Digital Technologies: Advancing Basic Molecular Research',
      speaker: "Dr. Andria Garevito, CIRAD, France"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '12:00 - 13:00',
      room: '',
      activities: 'Lunch',
      speaker: ''
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: 'Session',
      room: '',
      activities: 'Session 7: Resilient Coconut Futures: Bridging Genetics, Smart Agriculture, and the Bioeconomy',
      speaker: ''
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '13:00 - 13:30',
      room: 'Vermillion',
      activities: '[O23] Sustainable Production and Dissemination of Three-Way Hybrid Coconuts to Thai Farmers',
      speaker: "Ms. Tippaya Kraitong\\nDirector of Chumphon Horticulture Research Center, Horticulture Research Institute, Thailand"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '13:30 - 14:00',
      room: 'Vermillion',
      activities: '[O20] Navigating molecular diagnostics to strengthen pest surveillance for resilient trade and shared prosperity',
      speaker: "Dr. Justine Milado, Visayas University, Philippines"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '14:00 - 14:30',
      room: 'Vermillion',
      activities: '[O27] Innovation-Driven and Sustainable Development of Thai Coconut Products',
      speaker: "Ms.Sarapee Yuadyong, Managing Director of Chiwadi Productss, Thailand"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: 'Oral Presentation',
      room: '',
      activities: 'Session 1: Climate Change Impacts and Adaptive Strategies for Tropical Agriculture',
      speaker: "Convener: Prof. Dr. Simon Wang\\nProf. Yun Zheng"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '13:15 - 13:30',
      room: 'Flavio',
      activities: 'A Weatherman\'s Take on Future Climate Extremes in Southeast Asia',
      speaker: "Prof. Dr. Simon Wang, Kasetsart University"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '13:30 - 13:45',
      room: 'Flavio',
      activities: '[O01] Multiomics analysis of flowers reveals that enlarged epidermic cell of petal is the major reason of large flowers of Gypsophila paniculata L.',
      speaker: "Prof. Yun Zheng, Yunan Agriculture University"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '13:45 - 14:00',
      room: 'Flavio',
      activities: '[O08] Inoculation of wheat seeds with spore-forming bacteria as a novel approach to enhance growth under climate change-induced stress conditions',
      speaker: "Shafiqullah Aryan, Tokyo University of Agriculture and Technology"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '14:00 - 14:15',
      room: 'Flavio',
      activities: '[O10] Prospects of Plant Growth-Promoting Rhizobacteria from Different Plant Rhizospheres as Biofertilizers for Diverse Crops in Japan',
      speaker: "Safiullah Habibi, Tokyo University of Agriculture and Technology"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '14:15 - 14:30',
      room: 'Flavio',
      activities: '[O11] Growth Responses of Rice to Viable and Non-Viable Bacillus Spores',
      speaker: "Ali Yawar Seerat, Tokyo University of Agriculture and Technology"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '14:30 - 14:45',
      room: 'Flavio',
      activities: '[O28] Performance of Alginate-Gelatin Hydrogel-Coated Maize Seed during Germination and Seedling Establishment under Limited Water Condition',
      speaker: "Panuphun Boonsuebsakoon, Kasetsart University"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: 'Oral Presentation',
      room: '',
      activities: 'Session 3: Advanced Breeding and Biotechnology for Climate-Resilient Tropical Crops',
      speaker: "Convener : Prof. Dr. Zhiqiang Xia"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '13:15 - 13:30',
      room: 'Fineen',
      activities: 'AI for Plants: Research on Tropical Plant Genomes Driven by Artificial Intelligence',
      speaker: "Prof. Dr. Zhiqiang Xia, Sanya Institute of Breeding and Multiplication"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '13:30 - 13:45',
      room: 'Fineen',
      activities: 'Research Progress on the Genome of Sesbania Genus and its Breeding Application',
      speaker: "Assoc.Prof. Fuqiang Wang, Hainan Seed Industry Laboratory"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '13:45 - 14:00',
      room: 'Fineen',
      activities: 'Multi-omics decipher the metabolic basis of flavor and nutritional quality in tropical fruits',
      speaker: "Prof. Wenquan Wang, Hainan University"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '14:00 - 14:15',
      room: 'Fineen',
      activities: '[O21] NKI17196-102-2-1-1-1-SKN-1: A Promising Photoperiod Insensitive Glutinous Rice Line with Blast Resistance for Irrigated Lowland Area in Northeastern Thailand',
      speaker: "Surachet Chamontri, Sakon Nakhon Rice Research Center"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '14:15 - 14:30',
      room: 'Fineen',
      activities: '[O22] Carotenoid Accumulation and Regulation of Carotenogenic Gene Expression During Ripening of Red-Fleshed Siam Red Ruby Pumelo (Citrus grandis)',
      speaker: "Assoc. Prof. Dr. Samak Kaewsuksaeng, Thaksin University"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '14:30 - 14:45',
      room: 'Fineen',
      activities: '[O26] Reconceptualizing Cassava: Regional Approaches to Breeding, Processing, and Market Integration',
      speaker: "Vishnuvardhan Reddy Banda, International Institute of Tropical Agriculture (IITA)"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '14:45 - 15:00',
      room: 'Fineen',
      activities: 'Genetic Dissection of Root Crown Architecture Using 3D Modelling for Yield Improvement',
      speaker: "Assoc. Prof. Supachai Vuttipongchaikij, Kasetsart University"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '15:00 - 15:15',
      room: 'Fauna',
      activities: 'Coffee Break / Poster Session',
      speaker: ''
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: 'Oral Presentation',
      room: '',
      activities: 'Session 3: Advanced Breeding and Biotechnology for Climate-Resilient Tropical Crops (continued)',
      speaker: "Convener : Prof. Dr. Zhiqiang Xia"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '15:15 - 15:30',
      room: 'Fineen',
      activities: 'Cassava Breeding for Cassava Mosaic Disease Resistance at Kasetsart University',
      speaker: "Prof. Piya Kittipadakul, Kasetsart University"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '15:30 - 15:45',
      room: 'Fineen',
      activities: 'Driving Genome Innovation: Complete T2T Genomes and Multi-Omics Solutions',
      speaker: "Xiaojun Su, Sailgene Technology (Hong Kong) Co., Ltd."
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '15:45 - 16:00',
      room: 'Fineen',
      activities: 'Application of Multi-omics in Tropical Crop Research',
      speaker: "Dr. Xiaoyun Wu, SanshuBio, China"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '16:00 - 16:15',
      room: 'Fineen',
      activities: '[O04] QTL-seq Identifies a Wall-associated Kinase as a New Resistance Gene to Bacterial Leaf Streak in Rice',
      speaker: "Moe Moe Kyi Win, Kasetsart University Kamphaeng Saen Campus"
    },
    {
      date: 'Tuesday, March 24, 2026',
      time: '16:15 - 16:45',
      room: 'Fineen',
      activities: 'Closing Remarks',
      speaker: ''
    },
    {
      date: 'Wednesday, March 25, 2026',
      time: '',
      room: '',
      activities: 'Field Trip Program',
      speaker: ''
    },
    {
      date: 'Wednesday, March 25, 2026',
      time: '07:00 - 09:00',
      room: '',
      activities: 'Depart from The Zign Hotel Pattaya to Kubota Farm',
      speaker: ''
    },
    {
      date: 'Wednesday, March 25, 2026',
      time: '09:00 - 12:00',
      room: '',
      activities: 'Educational tour and exploration of Kubota Farm',
      speaker: ''
    },
    {
      date: 'Wednesday, March 25, 2026',
      time: '12:00 - 13:00',
      room: '',
      activities: 'Lunch',
      speaker: ''
    },
    {
      date: 'Wednesday, March 25, 2026',
      time: '13:00 - 14:15',
      room: '',
      activities: 'Depart from Kubota Farm to Rayong',
      speaker: ''
    },
    {
      date: 'Wednesday, March 25, 2026',
      time: '14:15 - 15:30',
      room: '',
      activities: 'Site Visit at Farm Ruenrom',
      speaker: ''
    },
    {
      date: 'Wednesday, March 25, 2026',
      time: '15:30 - 17:30',
      room: '',
      activities: 'Depart from Farm Ruenrom to The Zign Hotel Pattaya',
      speaker: ''
    },
    {
      date: 'Wednesday, March 25, 2026',
      time: '',
      room: '',
      activities: 'Workshop on Coconut Genomics: From Coconut DNA to Breeding Applications',
      speaker: "Moderators: Dr. Siwaret Arikit, Associate Professor, KU, Dr. Stephanie Bocs, CIRAD, France, Dr. Samart Wanchana, NSTDA, Dr. Wasin Ponchewin, NSTDA, Thailand"
    },
    {
      date: 'Wednesday, March 25, 2026',
      time: '09:00 - 16:45',
      room: 'Vermillion',
      activities: 'Session 1: Coconut Genomics Landscape | Session 2: SNP Data Handling & Quality Control | Session 3: Genetic Diversity & Population Structure | Session 4: GWAS and Trait Mapping in Coconut | Session 5: Genomic Selection for Coconut | Session 6: Data Sharing & International Collaboration | Session 7: Discussion & Future Roadmap',
      speaker: ''
    }]
    );

    const conferenceTableRows = computed(() => conferenceSchedule.value.map((item) => {
      let startTime = '';
      let endTime = '';
      if (/^\d{2}:\d{2}\s*-\s*\d{2}:\d{2}$/.test(item.time)) {
        const [start, end] = item.time.split('-').map((s) => s.trim());
        startTime = start;
        endTime = end;
      }

      const rawTitle = item.activities || '';
      const codeMatch = rawTitle.match(/^\[(O\d+)\]\s*/i);
      const code = codeMatch ? codeMatch[1].toUpperCase() : '';
      const title = codeMatch ? rawTitle.replace(/^\[(O\d+)\]\s*/i, '') : rawTitle;

      return {
        ...item,
        startTime,
        endTime,
        code,
        title,
        speakerPresenter: item.speaker || ''
      };
    }));

    const groupedConferenceRows = computed(() => {
      const groups = [];
      const order = [];
      const bucket = {};

      conferenceTableRows.value.forEach((row) => {
        if (!bucket[row.date]) {
          bucket[row.date] = [];
          order.push(row.date);
        }
        bucket[row.date].push(row);
      });

      order.forEach((date, index) => {
        groups.push({
          dayLabel: `Day ${index + 1}: ${date}`,
          rows: bucket[date]
        });
      });

      return groups;
    });

    const formatSpeakerPresenter = (text = '') => {
      if (!text) return '';
      const normalizedText = text.replace(/\\n/g, '\n');
      const pipeSplit = normalizedText.split('|').map((item) => item.trim()).filter(Boolean);
      const lines = pipeSplit.length > 0 ? pipeSplit : normalizedText.split('\n').map((item) => item.trim());
      return lines.filter(Boolean).join('\n').replace(/\*\*/g, '').replace(/\n/g, '<br>');
    };
    const formatTitle = (text = '') => {
      if (!text) return '';
      const normalizedText = text.replace(/\\n/g, '\n');
      const pipeSplit = normalizedText.split('|').map((item) => item.trim()).filter(Boolean);
      const lines = pipeSplit.length > 0 ? pipeSplit : normalizedText.split('\n').map((item) => item.trim());
      return lines.filter(Boolean).join('\n').replace(/\n/g, '<br>');
    };
    const sessionsData = ref([
    {
      session: 'Session 1: Climate Change Impacts and Adaptive Strategies for Tropical Agriculture',
      focus: 'Climate risks and adaptation strategies for tropical agriculture.',
      convener: `Prof. Dr. Simon Wang
Prof. Yun Zheng`,
      speakers: [
      'Prof. Dr. Simon Wang - A Weatherman\'s Take on Future Climate Extremes in Southeast Asia',
      'Prof. Yun Zheng - Multiomics analysis of flowers in Gypsophila paniculata L.',
      'Shafiqullah Aryan - Inoculation of wheat seeds with spore-forming bacteria under climate stress',
      'Safiullah Habibi - Plant Growth-Promoting Rhizobacteria as biofertilizers',
      'Ali Yawar Seerat - Growth Responses of Rice to Viable and Non-Viable Bacillus Spores',
      'Panuphun Boonsuebsakoon - Alginate-Gelatin Hydrogel-Coated Maize Seed performance']

    },
    {
      session: 'Session 2: Physiological and Molecular Mechanisms of Stress Tolerance in Tropical Plants',
      focus: 'Molecular and physiological mechanisms underlying stress tolerance.',
      convener: `Prof. Dr. Yinghua Chen
Assoc. Prof. Sutkhet Nakasathien`,
      speakers: [
      'Elvian Indah Nilamsari - Single Nucleus RNA-sequencing for xylem vessel patterning',
      'Liu, Ji-Hong - Molecular regulation of sugar accumulation in citrus under cold stress',
      'Yinhua Chen - Regulation of Cassava Immune Response by Xpm typeIII effectors',
      'Liyun Yang - XopAG in regulating cassava immune response',
      'Peerasak Chaiprasart - Chitosan + 1-MCP effects on MD2 pineapple storage',
      'Phanchita Vejchasarn - Climate-smart rice genomics under drought',
      'Supatthra Narawatthana - Multi-omics mechanisms of salt tolerance in rice',
      'Suparad Klinsawang - QTL-Seq insight into root penetration under compaction',
      'Watchara Phetluan - Mega-papillae formation in rice via QTL-seq and GWAS']

    },
    {
      session: 'Session 3: Advanced Breeding and Biotechnology for Climate-Resilient Tropical Crops',
      focus: 'Breeding and biotechnology approaches for resilient tropical crops.',
      convener: 'Prof. Dr. Zhiqiang Xia',
      speakers: [
      'Prof. Dr. Zhiqiang Xia - AI for Plants',
      'Assoc. Prof. Fuqiang Wang - Genome of Sesbania and breeding applications',
      'Prof. Wenquan Wang - Multi-omics for flavor and nutrition in tropical fruits',
      'Surachet Chamontri - [O21] Photoperiod insensitive glutinous rice line',
      'Assoc. Prof. Dr. Samak Kaewsuksaeng - [O22] Carotenoid accumulation in Siam Red Ruby pumelo',
      'Vishnuvardhan Reddy Banda - [O26] Reconceptualizing cassava',
      'Assoc. Prof. Supachai Vuttipongchaikij - Root crown architecture using 3D modelling',
      'Prof. Piya Kittipadakul - Cassava mosaic disease resistance breeding',
      'Xiaojun Su - Complete T2T genomes and multi-omics solutions',
      'Dr. Xiaoyun Wu - Application of multi-omics in tropical crops',
      'Moe Moe Kyi Win - [O04] WAK resistance gene to bacterial leaf streak in rice']

    },
    {
      session: 'Session 4: Smart Agriculture, Forestry, & Plant Protection in Tropical Regions',
      focus: 'Smart agriculture, forestry, and plant protection in tropical systems.',
      convener: 'Prof. Youxiong Que | Prof. Huang Xi',
      speakers: [
      'Prof. Huang Xi - Areca palm velarivirus proteins and antiviral RNA silencing',
      'Prof. Peitao Lu - Epigenetic regulation of chilling injury in banana fruit',
      'Nutchanon Phichadul - Regenerative design for agriculture service providers',
      'Nattaporn Prakongkep - Optimized root zone management for Camellia oleifera',
      'Thanapat Nilwaranon - RGB canopy size vs. destructively measured biomass in holy basil',
      'Jutiporn Thussagunpanit - UV-A + CO2 effects on kale traits and phytonutrients']

    },
    {
      session: 'Session 5: Discovery and Characterization of Novel Bioactive Compounds from Tropical Plants',
      focus: 'Discovery and characterization of novel bioactive compounds from tropical plants.',
      convener: 'TBC',
      speakers: [
      'Thanarut Chinnapan - [O13] CPPU and boric acid on off-season lychee flowering',
      'Chutchamas Kanchana-udomkan - [O24] Aroma profiles and consumer preference in landrace chilli']

    },
    {
      session: 'Session 6: Tropical Plants in Carbon Sequestration and the Bioeconomy',
      focus: 'Tropical plants in carbon sequestration and bioeconomy pathways.',
      convener: 'Prof. Peng Xu',
      speakers: [
      'Prof. Huafeng Wang - Aboveground biomass of urban trees in tropical Hainan',
      'Dr. Jinpeng Wan - Mechanism of grain amaranth tolerance to salt-alkali stress',
      'Dr. Yuhua Chen - T2T haplotype-resolved genome and abiu fruit ripening']

    },
    {
      session: 'Session 7: Resilient Coconut Futures: Bridging Genetics, Smart Agriculture, and the Bioeconomy',
      focus: 'Coconut genetics, smart agriculture, and bioeconomy integration.',
      convener: 'International Coconut Community (ICC) track',
      speakers: [
      'Dr. Niral Vittal - [O16] Leveraging Molecular Breeding for Market Competitiveness',
      'Dr. Bart Panis - [O17] Coconut tissue culture developments',
      'Dr. Anjana Atapattu - [O18] Coconut agronomy and international trade',
      'Dr. Samart Wanchana - [O15] Genomic & Molecular Breeding',
      'Dr. Andria Garevito - [O19] AI & digital technologies',
      'Ms. Tippaya Kraitong - [O23] Three-way hybrid coconuts to Thai farmers',
      'Dr. Justine Milado - [O20] Molecular diagnostics for pest surveillance',
      'Ms. Sarapee Yuadyong - [O27] Sustainable development of Thai coconut products']

    }]
    );

    const keynoteSpeakers = ref([
    { number: 1, name: 'Dr. Piyarat Thammakijjawat', topic: 'Advancing Thai Agriculture: Genome Editing for Global Sustainability and Economic Resilience' },
    { number: 2, name: 'Prof. Jie Luo', topic: 'The evolution and domestication of coconut (online)' },
    { number: 3, name: 'Prof. Robert Henry', topic: 'Engineering Tropical Plants to Replace Fossil Carbon' },
    { number: 4, name: 'Prof. Chengtao Lin', topic: 'Cryptochromes and plant highlight responses' },
    { number: 5, name: 'Dr. Jelfina Alouw', topic: 'From Germplasm to Global Markets: Advancing Coconut Research Excellence, Crop Protection, and Evidence-Based Governance' },
    { number: 6, name: 'Prof. Apichart Vanavichit', topic: 'Improving Rice to Sustain One Health' },
    { number: 7, name: 'Prof. Hongwen Huang', topic: 'From wild plants to novel calcium-rich vegetables' },
    { number: 8, name: 'Assoc. Prof. Wirat Vanichsriratana', topic: 'Thai Sugar Industries: Toward Sustainability' },
    { number: 9, name: 'Dr. Sean Fenstemaker', topic: 'The efficiency myth of polycrossing in cassava: evidence from the crossing nursery' },
    { number: 10, name: 'Prof. Youxiong Que', topic: 'Sugarcane breeding: theoretical thinking and practical exploration' },
    { number: 11, name: 'Prof. Dr. Randy Beaudry', topic: 'Storage of the difficult mango, a climacteric fruit that refuses to play by the rules' }]
    );

    return {
      tableData,
      spanMethod,
      sections,
      toggleSection,
      conferenceSchedule,
      conferenceTableRows,
      groupedConferenceRows,
      formatTitle,
      formatSpeakerPresenter,
      sessionsData,
      keynoteSpeakers
    };
  }
};
</script>

<template>
  <div class="program">
    <h1 class="program-title" @click="toggleSection(0)">Keynote Speakers</h1>
    <div class="content" v-show="sections[0].visible">
      <div v-for="speaker in keynoteSpeakers" :key="speaker.number" class="speaker-item">
        <p><strong>{{ speaker.number }}. {{ speaker.name }}</strong></p>
        <p v-if="speaker.topic"><strong>Topic:</strong> {{ speaker.topic }}</p>
      </div>
    </div>
    <br>

    <h1 class="program-title" @click="toggleSection(1)">Sessions with Conveners</h1>
    <div class="content" v-show="sections[1].visible">
      <div v-for="session in sessionsData" :key="session.session" class="session-item">
        <h2>{{ session.session }}</h2>
        <p v-if="session.focus"><strong>Focus:</strong> {{ session.focus }}</p>
        <p v-if="session.convener"><strong>Convener:</strong></p>
        <p v-if="session.convener" v-html="session.convener.replace(/\n/g, '<br>')"></p>
        <p v-if="session.speakers && session.speakers.length"><strong>Speakers:</strong></p>
        <ul v-if="session.speakers && session.speakers.length" class="speaker-list">
          <li v-for="speaker in session.speakers" :key="speaker">{{ speaker }}</li>
        </ul>
      </div>
    </div>
    <br>

    <h1 class="program-title" @click="toggleSection(2)">Scientific Program</h1>
    <div class="content" v-show="sections[2].visible">
      <div v-for="group in groupedConferenceRows" :key="group.dayLabel" class="day-section">
        <h2 class="day-heading">{{ group.dayLabel }}</h2>
        <el-table :data="group.rows"
                  :header-cell-style="{ textAlign: 'center', backgroundColor: '#F5F7FA' }"
                  border
                  style="width: 100%">
          <el-table-column prop="startTime" label="Starting Time" width="130"></el-table-column>
          <el-table-column prop="endTime" label="End time" width="110"></el-table-column>
          <el-table-column prop="code" label="Code" width="90"></el-table-column>
          <el-table-column prop="room" label="Room" width="140"></el-table-column>
          <el-table-column prop="title" label="Title" min-width="420">
            <template #default="scope">
              <div class="multiline-cell" v-html="formatTitle(scope.row.title)"></div>
            </template>
          </el-table-column>
          <el-table-column prop="speakerPresenter" label="Speaker / Presenter" min-width="320">
            <template #default="scope">
              <div class="multiline-cell" v-html="formatSpeakerPresenter(scope.row.speakerPresenter)"></div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <br>
  </div>
</template>

<style scoped>
.program {
  max-width: 70%;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
}

.program-title{
  background-color: rgb(233, 243, 246);
  text-align: center;
  padding: 20px;
  cursor: pointer;
}

.content{
  padding: 10px;
  font-family: Arial, sans-serif;
  line-height: 1.6;
}

ul {
  list-style-type: disc;
  margin-left: 20px;
}

.session-item {
  margin-bottom: 20px;
}

.session-item h2 {
  color: #333;
  margin-bottom: 10px;
}

.session-item p {
  margin: 5px 0;
}

.day-section {
  margin-bottom: 22px;
}

.day-heading {
  margin: 12px 0 10px;
  font-size: 20px;
  color: #1f2937;
}

.speaker-item {
  margin-bottom: 15px;
}

.speaker-item p {
  margin: 5px 0;
}

.multiline-cell {
  white-space: pre-line;
  line-height: 1.45;
}
</style>
